var map = {
	"./arrows/next": 6,
	"./arrows/next.png": 6,
	"./arrows/prev": 7,
	"./arrows/prev.png": 7,
	"./arrows/tail-spin": 8,
	"./arrows/tail-spin.svg": 8,
	"./icons/check-green": 9,
	"./icons/check-green.svg": 9,
	"./icons/close": 10,
	"./icons/close.svg": 10,
	"./icons/cookies": 11,
	"./icons/cookies.svg": 11,
	"./icons/cross": 12,
	"./icons/cross.svg": 12,
	"./icons/email": 13,
	"./icons/email-red": 14,
	"./icons/email-red.png": 14,
	"./icons/email.png": 13,
	"./icons/fb": 15,
	"./icons/fb.svg": 15,
	"./icons/linkedin": 16,
	"./icons/linkedin.svg": 16,
	"./icons/marker": 17,
	"./icons/marker.png": 17,
	"./icons/phone": 18,
	"./icons/phone-red": 19,
	"./icons/phone-red.png": 19,
	"./icons/phone.png": 18,
	"./icons/place": 20,
	"./icons/place-red": 21,
	"./icons/place-red.png": 21,
	"./icons/place.png": 20,
	"./icons/twitter": 22,
	"./icons/twitter.svg": 22,
	"./logo": 23,
	"./logo-carnis": 24,
	"./logo-carnis.png": 24,
	"./logo.png": 23,
	"./logo/auchan": 25,
	"./logo/auchan.png": 25,
	"./logo/carrefour": 26,
	"./logo/carrefour.png": 26,
	"./logo/kaufland": 27,
	"./logo/kaufland.png": 27,
	"./logo/lewiatan": 28,
	"./logo/lewiatan.png": 28,
	"./logo/stokrotka": 29,
	"./logo/stokrotka.png": 29,
	"./pic/1": 30,
	"./pic/1.jpg": 30,
	"./pic/certificates/about-us/1": 31,
	"./pic/certificates/about-us/1.jpg": 31,
	"./pic/certificates/about-us/2": 32,
	"./pic/certificates/about-us/2.jpg": 32,
	"./pic/certificates/about-us/big/brc": 33,
	"./pic/certificates/about-us/big/brc-global-en": 34,
	"./pic/certificates/about-us/big/brc-global-en.jpg": 34,
	"./pic/certificates/about-us/big/brc-global-pl": 35,
	"./pic/certificates/about-us/big/brc-global-pl.jpg": 35,
	"./pic/certificates/about-us/big/brc.jpg": 33,
	"./pic/certificates/about-us/thumb/brc": 36,
	"./pic/certificates/about-us/thumb/brc-global-en": 37,
	"./pic/certificates/about-us/thumb/brc-global-en.jpg": 37,
	"./pic/certificates/about-us/thumb/brc-global-pl": 38,
	"./pic/certificates/about-us/thumb/brc-global-pl.jpg": 38,
	"./pic/certificates/about-us/thumb/brc.jpg": 36,
	"./pic/certificates/brc-food": 39,
	"./pic/certificates/brc-food.png": 39,
	"./pic/certificates/dobra-firma": 40,
	"./pic/certificates/dobra-firma.png": 40,
	"./pic/certificates/forbes": 41,
	"./pic/certificates/forbes-2022": 42,
	"./pic/certificates/forbes-2022.png": 42,
	"./pic/certificates/forbes.png": 41,
	"./pic/certificates/forum-firm": 43,
	"./pic/certificates/forum-firm.png": 43,
	"./pic/certificates/gazele-2010": 44,
	"./pic/certificates/gazele-2010.png": 44,
	"./pic/certificates/gazele-2011": 45,
	"./pic/certificates/gazele-2011.png": 45,
	"./pic/certificates/ifs-food": 46,
	"./pic/certificates/ifs-food.png": 46,
	"./pic/certificates/produkt-najwyzszej-jakosci": 47,
	"./pic/certificates/produkt-najwyzszej-jakosci.png": 47,
	"./pic/certificates/qafp": 48,
	"./pic/certificates/qafp.png": 48,
	"./pic/certificates/top-product": 49,
	"./pic/certificates/top-product.png": 49,
	"./pic/chess": 50,
	"./pic/chess.jpg": 50,
	"./pic/cold-cuts": 51,
	"./pic/cold-cuts.jpg": 51,
	"./pic/cold-room": 52,
	"./pic/cold-room.webp": 52,
	"./pic/customers": 53,
	"./pic/customers.jpg": 53,
	"./pic/handshake": 54,
	"./pic/handshake.jpg": 54,
	"./pic/hero/farm": 55,
	"./pic/hero/farm.webp": 55,
	"./pic/hero/hall": 56,
	"./pic/hero/hall.webp": 56,
	"./pic/hero/hero": 57,
	"./pic/hero/hero.webp": 57,
	"./pic/hero/meat": 58,
	"./pic/hero/meat.webp": 58,
	"./pic/hero/news": 59,
	"./pic/hero/news.webp": 59,
	"./pic/hero/pigs": 60,
	"./pic/hero/pigs.webp": 60,
	"./pic/hero/product": 61,
	"./pic/hero/product.webp": 61,
	"./pic/hero/team": 62,
	"./pic/hero/team.webp": 62,
	"./pic/hero/woman": 63,
	"./pic/hero/woman.webp": 63,
	"./pic/hero/work": 64,
	"./pic/hero/work.webp": 64,
	"./pic/human-resources": 65,
	"./pic/human-resources.jpg": 65,
	"./pic/kpo": 66,
	"./pic/kpo.png": 66,
	"./pic/map": 67,
	"./pic/map.png": 67,
	"./pic/meat": 68,
	"./pic/meat-2": 69,
	"./pic/meat-2.jpg": 69,
	"./pic/meat-3": 70,
	"./pic/meat-3.jpg": 70,
	"./pic/meat-and-rosemary": 1,
	"./pic/meat-and-rosemary.jpg": 1,
	"./pic/meat-and-rosemary.webp": 96,
	"./pic/meat-board": 2,
	"./pic/meat-board.jpg": 2,
	"./pic/meat-board.webp": 97,
	"./pic/meat-transport": 71,
	"./pic/meat-transport.webp": 71,
	"./pic/meat.webp": 68,
	"./pic/meeting": 3,
	"./pic/meeting.jpeg": 3,
	"./pic/meeting.webp": 98,
	"./pic/news-main": 72,
	"./pic/news-main.jpg": 72,
	"./pic/parowki": 4,
	"./pic/parowki.jpg": 4,
	"./pic/parowki.webp": 99,
	"./pic/people": 73,
	"./pic/people.jpg": 73,
	"./pic/pigs": 74,
	"./pic/pigs.jpg": 74,
	"./pic/production-hall": 75,
	"./pic/production-hall.webp": 75,
	"./pic/products/karkowka": 76,
	"./pic/products/karkowka.jpg": 76,
	"./pic/products/lopatka": 77,
	"./pic/products/lopatka.jpg": 77,
	"./pic/products/tluszcz-twardy": 78,
	"./pic/products/tluszcz-twardy.jpg": 78,
	"./pic/program-rozwoju-obszarow-wiejskich": 0,
	"./pic/program-rozwoju-obszarow-wiejskich.jpeg": 0,
	"./pic/program-rozwoju-obszarow-wiejskich.jpg": 100,
	"./pic/program-rozwoju-obszarow-wiejskich.webp": 101,
	"./pic/sample1": 79,
	"./pic/sample1.jpg": 79,
	"./pic/sample2": 80,
	"./pic/sample2.jpg": 80,
	"./pic/sample3": 81,
	"./pic/sample3.jpg": 81,
	"./pic/sausages": 82,
	"./pic/sausages.jpg": 82,
	"./pic/schab": 5,
	"./pic/schab.jpg": 5,
	"./pic/schab.webp": 102,
	"./pic/talk": 83,
	"./pic/talk.jpg": 83,
	"./pic/tree": 84,
	"./pic/tree.jpg": 84,
	"./pic/truck": 85,
	"./pic/truck.jpg": 85,
	"./pic/worker": 86,
	"./pic/worker.jpg": 86
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95;